import watchBusinessInfo from './businessInfo'

export default watchBusinessInfo
